/**
 * The console mark (Figma: Components › Logo) — an ink tile with a white K and
 * the name beside it. Rendered as text so it stays crisp and themable; the
 * tile is decorative, the word is the accessible name.
 */
export function KalqyMark({
  href = '#/',
  label = 'Kalqy home',
  tone = 'default',
}: {
  href?: string | null
  label?: string
  /** `inverse` sits on a dark panel: a white tile and a white wordmark. */
  tone?: 'default' | 'inverse'
}) {
  const inverse = tone === 'inverse'
  const body = (
    <>
      <span
        aria-hidden="true"
        className={`inline-flex h-8 w-8 items-center justify-center rounded-[9px] font-dash text-[16px] font-semibold ${
          inverse ? 'bg-white text-[#141413]' : 'bg-primary text-primary-ink'
        }`}
      >
        K
      </span>
      <span className={`font-dash text-[18px] font-semibold tracking-[-0.01em] ${inverse ? 'text-white' : 'text-ink'}`}>Kalqy</span>
    </>
  )
  if (href === null) return <span className="inline-flex items-center gap-2.5">{body}</span>
  return (
    <a
      href={href}
      aria-label={label}
      className="inline-flex items-center gap-2.5 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-4 focus-visible:ring-offset-surface"
    >
      {body}
    </a>
  )
}
